import { Controller } from "@hotwired/stimulus";

/**
 * Form Submission Controller
 *
 * This controller handles automatic form submission on input change.
 *
 * Example:
 * <form data-controller="form-submission">
 *   <select data-action="change->form-submission#submit">
 *     <option value="1">Option 1</option>
 *     <option value="2">Option 2</option>
 *   </select>
 * </form>
 */
export default class extends Controller {
  connect() {
    console.log("Form submission controller connected");
  }

  submit() {
    // Soumettre le formulaire automatiquement lors de changement
    this.element.requestSubmit();
  }
}
